/**************
 Desktop Nav
 ***************/
document.querySelectorAll(".headerNavItem").forEach((nav_item) => {
    nav_item.querySelector(".headerNavItemBtn").addEventListener("click", function () {
        // close all dropdowns except for the desired one
        document.querySelectorAll(".headerNavItemDropdown").forEach((item) => {
            if (item !== nav_item.querySelector(".headerNavItemDropdown")) {
                item.close();
            }
        });
        // Open the clicked button drop down
        // close it if it's already open
        if (nav_item.querySelector(".headerNavItemDropdown").open) {
            nav_item.querySelector(".headerNavItemDropdown").close();
        } else {
            nav_item.querySelector(".headerNavItemDropdown").show();
        }
    });
});


/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// mobile nav dropdown listener
document.querySelectorAll(".sliderNavItem").forEach((item) => {
    const dropDownToggle = item.querySelector(".sliderNavItemBtn");
    const dropDownItem = item.querySelector(".sliderNavItemDropdown");

    dropDownToggle.addEventListener("click", function (event) {
        this.classList.toggle("active");
    })
})